import request from 'api/request';

export default function joinCourse({ id, ...data }) {
  if (Number.isInteger(id) && id > 0) {
    return request({ url: `/courses/${id}/join`, method: 'POST', data });
  } else {
    return request({ url: '/courses/join', method: 'POST', data });
  }
}
